import { createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "patners"
};
import CloudinaryImage from "@/components/CloudinaryImage.vue";
export default {
  __name: 'patners',
  setup(__props) {
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("nav", _hoisted_1, [_createElementVNode("ul", null, [_createElementVNode("li", null, [_createVNode(CloudinaryImage, {
        class: "partner-img",
        imageName: "abc_jea9rx.svg"
      })]), _createElementVNode("li", null, [_createVNode(CloudinaryImage, {
        class: "partner-img",
        imageName: "washingtonpost_lu8nym.svg"
      })]), _createElementVNode("li", null, [_createVNode(CloudinaryImage, {
        class: "partner-img forbes",
        imageName: "forbes-2_oh3bzr"
      })]), _createElementVNode("li", null, [_createVNode(CloudinaryImage, {
        class: "partner-img",
        imageName: "los_ov1xcs"
      })]), _createElementVNode("li", null, [_createVNode(CloudinaryImage, {
        class: "partner-img",
        imageName: "Chicago_qorbfb"
      })]), _createElementVNode("li", null, [_createVNode(CloudinaryImage, {
        class: "partner-img usa-today",
        imageName: "usa-today-seeklogo.com_wu0cpd.svg"
      })])])]);
    };
  }
};